import { render, staticRenderFns } from "./OrderManifest.vue?vue&type=template&id=05da4724"
import script from "./OrderManifest.vue?vue&type=script&lang=js"
export * from "./OrderManifest.vue?vue&type=script&lang=js"
import style0 from "./OrderManifest.vue?vue&type=style&index=0&id=05da4724&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports